import type { FC, RefObject } from 'react';
import { createContext, useCallback, useState } from 'react';

interface TabBarData {
  tabBarHeight: number;
  handleTabBarHeight: (ref: RefObject<HTMLDivElement>) => void;
}

export const TabBarContext = createContext<TabBarData>(null as any);

export const TabBarContextProvider: FC = ({ children }) => {
  const [tabBarHeight, setTabBarHeight] = useState(0);

  const handleTabBarHeight = useCallback((ref: RefObject<HTMLDivElement>) => {
    if (ref === null) return;

    if (ref.current?.clientHeight)
      return setTabBarHeight(ref.current?.clientHeight);

    return setTabBarHeight(0);
  }, []);

  return (
    <TabBarContext.Provider
      value={{
        tabBarHeight,
        handleTabBarHeight,
      }}
    >
      {children}
    </TabBarContext.Provider>
  );
};
